import React, { useState } from 'react';
import { Mail, Gift, Star, ArrowRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const Newsletter = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [isSubscribed, setIsSubscribed] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      setIsSubscribed(true);
      setEmail('');
      setTimeout(() => setIsSubscribed(false), 3000);
    }
  };

  return (
    <section className="py-16 bg-gradient-to-r from-[#4ECDC4] to-[#95C11F] relative overflow-hidden">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
        {/* Icon */}
        <div className="flex justify-center mb-6">
         <div className="bg-white bg-opacity-20 p-4 rounded-full">
           <Mail className="w-8 h-8 text-white" />
         </div>
       </div>

       {/* Title */}
       <h2 className="text-3xl lg:text-4xl font-bold text-white mb-4">
         {t('newsletter.joinSubtitle')}
       </h2>

       {/* Subtitle */}
       <p className="text-xl text-white opacity-90 mb-8 max-w-2xl mx-auto">
         {t('newsletter.joinDesc')}
       </p>

       {/* Benefits */}
       <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
         <div className="flex items-center justify-center text-white">
           <Gift className="w-5 h-5 mr-2" />
           <span className="font-medium">{t('newsletter.benefits.discount')}</span>
         </div>
         <div className="flex items-center justify-center text-white">
           <Star className="w-5 h-5 mr-2" />
           <span className="font-medium">{t('newsletter.benefits.tips')}</span>
         </div>
         <div className="flex items-center justify-center text-white">
           <ArrowRight className="w-5 h-5 mr-2" />
           <span className="font-medium">{t('newsletter.benefits.access')}</span>
         </div>
       </div>

       {/* Newsletter Form */}
       {!isSubscribed ? (
         <form onSubmit={handleSubmit} className="max-w-md mx-auto">
           <div className="flex flex-col sm:flex-row gap-4">
             <input
               type="email"
               value={email}
               onChange={(e) => setEmail(e.target.value)}
               placeholder={t('newsletter.placeholder')}
               className="flex-1 px-6 py-4 rounded-full text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-4 focus:ring-white focus:ring-opacity-30"
               required
             />
             <button
               type="submit"
               className="bg-white text-[#4ECDC4] px-8 py-4 rounded-full font-bold hover:shadow-lg transform hover:-translate-y-0.5 transition-all duration-200 flex items-center justify-center"
             >
               {t('newsletter.subscribe')}
               <ArrowRight className="w-4 h-4 ml-2" />
             </button>
           </div>
         </form>
       ) : (
         <div className="max-w-md mx-auto">
           <div className="bg-white bg-opacity-20 rounded-full p-4">
             <p className="text-white font-bold text-lg">
               {t('newsletter.successTitle')}
             </p>
             <p className="text-white opacity-90">
               {t('newsletter.successMessage')}
             </p>
           </div>
         </div>
       )}

       {/* Disclaimer */}
       <p className="text-sm text-white opacity-75 mt-6">
         {t('newsletter.disclaimer')}
       </p>
     </div>

     {/* Background Decorations */}
     <div className="absolute top-0 left-0 w-64 h-64 bg-white opacity-10 rounded-full -translate-y-32 -translate-x-32"></div>
     <div className="absolute bottom-0 right-0 w-96 h-96 bg-white opacity-10 rounded-full translate-y-48 translate-x-48"></div>
   </section>
 );
};

export default Newsletter;
